import { ApplicationInsights, SeverityLevel } from '@microsoft/applicationinsights-web'
import { ImageConsentModalController } from './areas/home/imageConsent/ImageConsentModalController'

class BootstrapApp {
    public title: string;

    allowStatesForInvalidApplicant = ['app.home', 'app.logout', 'app.contact.interviewer', 'app.contact.agency', 'app.contact.london', 'app.settings.marketing', 'app.settings.password', 'app.settings.imageConsent', 'app.termsAndConditions', 'app.messages', 'app.settings.deleteMyData'];

    static $inject = ['$rootScope', '$location', '$window', '$state', '$stateParams', 'Menu', 'Auth', 'AccessLevel', 'PushHub', 'ApplicationInsights', '$anchorScroll', 'environment','localStorageService', '$uibModalStack', 'InterestedHostFamiliesDetails', 'ApplicationInstance', '$uibModal'];
    constructor($rootScope, $location, $window, $state, $stateParams, Menu, Auth, AccessLevel, PushHub, ApplicationInsights, $anchorScroll, environment, localStorageService, $uibModalStack, InterestedHostFamiliesDetails, ApplicationInstance, $uibModal) {

		$rootScope.$state = $state;
		$rootScope.$stateParams = $stateParams;
        $rootScope.Menu = Menu;
        $rootScope.environment = environment;

        const openImageConsentModal = (applicationId) => {
            $uibModal.open({
                templateUrl: 'areas/home/imageConsent/imageConsentModal.html',
                controller: ImageConsentModalController,
                controllerAs: 'ctrl',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    imageConsentData: () => ApplicationInstance(applicationId).toPromise()
                        .then(x => ({ applicationId: x.applicationId, existingConsent: x.imageConsent })),
                    applicationObservable: () => ApplicationInstance(applicationId)
                }
            });
        };

		$rootScope.$on('auth:user-change', (event, user) => {
            AccessLevel.apply(user.role).then(() => {
                const transition = (state, params) =>
                    $state.transitionTo(state, params, { reload: true, inherit: true, notify: true });

                if (!Auth.user.isLoggedIn) { return; }

                let targetState = $state.params.state;
                let targetParams = $state.params.params;

                if (targetState) {
                    transition(targetState, targetParams);
                    return;
                }

                if (Auth.user.role === 'OFF') {
                    transition('app.workQueue', { queueName: '' });
                    return;
                }

                const applicationId = Auth.user.isApplicant && Auth.user.roleDetails && Auth.user.roleDetails.applicationId;

                if (!applicationId) {
                    transition('app.home', { logInRedirect: true });
                    return;
                }

                ApplicationInstance(applicationId).toPromise().then((app) => {
                    const status = app && app.status;

                    const needsConsent = Auth.user.isApplicant && app &&
                        (app.imageConsent === null || app.imageConsent === undefined);
                    const go = (state, params) => {
                        const p = transition(state, params);
                        if (needsConsent) p.then(() => openImageConsentModal(applicationId), angular.noop);
                        return p;
                    };

                    if (status === 'OLA') { go('app.applications.inst.highlights', { applicationId: applicationId }); return; }
                    if (status === 'PLC') { go('app.placement.placementDetails', { applicationId: applicationId }); return; }
                    if (status === 'REM') { go('app.hostFamilies.interestedFamilies', { applicationId: applicationId }); return; }

                    if (status === 'TBM' || status === 'ACT') {
                        InterestedHostFamiliesDetails.count({
                            applicationId: applicationId
                        }, (data) => {
                            if (data.count > 0) {
                                go('app.hostFamilies.interestedFamilies', { applicationId: applicationId });
                            } else if (status === 'TBM') {
                                go('app.hostFamilies.howToRespond', { applicationId: applicationId });
                            } else {
                                // ACT with no interested families - land on home.
                                go('app.home', { logInRedirect: true });
                            }
                        }, () => go('app.home', { logInRedirect: true }));
                        return;
                    }

                    // Any other status - land on home.
                    go('app.home', { logInRedirect: true });
                }, () => {
                    // Only reached if fetching the application status itself failed.
                    transition('app.home', { logInRedirect: true });
                });
			});
		});


		$rootScope.$on('commun:new-message', function (event, message) {
			//if (message.userId != Auth.user.userId)
			//    toaster.pop('info', "You got new message from " + message.userName, message.text);
		});

        $rootScope.$on('$stateChangeError', (event, toState, toParams, fromState, fromParams, error) => {

            let targetState, targetParams;

            ApplicationInsights.trackException({
                exception: error,
                properties: {
                    toState,
                    toParams,
                    fromState,
                    fromParams
                }
            });


            if (error && error.reason === 'state_access_denied') {
                if (Auth.user && Auth.user.isLoggedIn) {
                    if (Auth.user.role === 'OFF') {
                        targetState = 'app.workQueue';
                        targetParams = { queueName: '' };
                    } else {
                        targetState = 'app.home';
                        targetParams = {};
                    }
                } else {
                    if (toState.name !== 'app.login') {
                         targetState = 'app.login';
                    } else {
                        targetState = 'app.logout'
                    }

                    targetParams = {
                        state: (toParams && toParams.state) || toState.name,
                        params: (toParams && toParams.params) || toParams
                    };
                }
            } else if (error && error.reason === 'business_area_required') {

                targetState = 'app.accessDenied';

                targetParams = {
                    reason: error.reason,
                    businessArea: error.businessArea
                };
            } else {
                if (Auth.user.role === 'OFF') {
                    targetState = 'app.workQueue';
                    targetParams = { queueName: '' };
                } else {
                    targetState = 'app.home';
                    targetParams = {};
                }
            }
                
            if (toState.name !== targetState) {
                $state.transitionTo(targetState, targetParams, { reload: true, inherit: true, notify: true });
            }
        });

        $rootScope.$on('$stateChangeStart', (event, toState, toParams, fromState, fromParams, options) =>
        {
            ApplicationInsights.trackPageView({
                name: toState?.name,
                properties: {
                    params: toParams,
                    fromState: fromState?.name,
                    fromParams
                }
            });

            AccessLevel.userLevelsPromise.then((userLevels) => {
                if (userLevels.invalidApplicant) {
                    if (!this.allowStatesForInvalidApplicant.includes(toState.name)) {
                        event.preventDefault();
                        $state.go('app.home');
                    }
                }
            });
        });

        var defaultTitle = $window.document.title;
        var defaultDescription = $window.document.getElementsByName('description')[0].content;
        var dataLayer = $window.dataLayer = $window.dataLayer || [];
        ///$window.ga('create', 'UA-2289997-7', 'auto');
        $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {

            $uibModalStack.dismissAll();
            
            ApplicationInsights.trackTrace({
                message: '$stateChangeSuccess',
                severityLevel: SeverityLevel.Information,
                properties: {
                    params: toParams,
                    fromState: fromState?.name,
                    fromParams
                }
            });

            $anchorScroll();
            //$('html, body').animate({ scrollTop: 0 }, 200);
            dataLayer.push({
                event: 'ngRouteChange',
                attributes: {
                    route: $location.path()
                }
            });
            $window.document.title = $state.$current.locals.globals.$title || defaultTitle;
            $window.document.getElementsByName('description')[0].content = $state.$current.locals.globals.$description || defaultDescription;
            
		});
        AccessLevel.apply(Auth.user.role);
    }

    redirectToHome() {
            
    }
}


export let app = angular
    .module('app', [
        'aifs.metaform',
        'ngResource',
        'ngMessages',
        'ui.router',
        'ui.bootstrap',
        'LocalStorageModule',
        'dialogs.main',
        'trNgGrid',
        'ngFileUpload',
        'ngSanitize',
        'trNgGrid',
        'ngclipboard',
        'com.2fdevs.videogular',
        "com.2fdevs.videogular.plugins.controls",
        'com.2fdevs.videogular.plugins.overlayplay',
        'com.2fdevs.videogular.plugins.poster',
        //'toaster'
        //'pascalprecht.translate'
        'app.reference',
        'mwl.calendar',
        'mwl.calendar.custom',
        'selector',
        'summernote',
        'rzSlider'

    ])
    .run(BootstrapApp);
